import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { getCspNonce } from './utils/csp';

// Option 1: Disable automatic CSS injection to avoid CSP violations
config.autoAddCss = false;

// Option 2: Apply the nonce to FontAwesome's dynamically added styles
// Uncomment this and comment out the autoAddCss line if you want FontAwesome
// to handle its own styles with proper CSP nonce
// config.styleDefault = { nonce: getCspNonce() };
